import { createReducer, on } from '@ngrx/store';

import { setInsurancePackages } from '@admin/store/insurance-packages/insurance-packages.actions';

import { InsurancePackage } from '@lib/core/models/insurance-package.interface';

export interface InsurancePackagesState {
  insurancePackages: InsurancePackage[];
}

const initialState: InsurancePackagesState = {
  insurancePackages: [],
};

export const insurancePackagesReducer = createReducer(
  initialState,
  on(setInsurancePackages, (state, { insurancePackages }) => ({ ...state, insurancePackages }))
);
